var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._b({domProps:{"textContent":_vm._s(_vm.$icon)}},'v-icon',_vm.iconProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }